import { APP_NAME, APP_TAGLINE, EXTERNAL_LINKS, SUPPORTED_LOCALES, type Locale } from "@/constants/config";
import { publicLocalePath } from "@/constants/routes";
import { getDictionary } from "@bizy/core/i18n/resolve";
import { Link } from "react-router-dom";

export const PublicFooter = ({ locale }: { locale: Locale }) => {
  const dictionary = getDictionary(locale);

  return (
    <footer className="border-t border-border bg-muted/40">
      <div className="mx-auto grid w-full max-w-6xl gap-8 px-4 py-10 sm:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-2">
          <p className="text-sm font-semibold">{APP_NAME}</p>
          <p className="text-[11px] uppercase tracking-wide text-primary">{APP_TAGLINE}</p>
          <p className="text-sm text-muted-foreground">{dictionary.footer.tagline}</p>
        </div>

        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            {dictionary.footer.product}
          </p>
          <ul className="space-y-1 text-sm">
            <li>
              <a href="#features" className="text-muted-foreground hover:text-foreground">
                {dictionary.nav.features}
              </a>
            </li>
            <li>
              <a href="#workflow" className="text-muted-foreground hover:text-foreground">
                {dictionary.nav.workflow}
              </a>
            </li>
            <li>
              <a href="#plans" className="text-muted-foreground hover:text-foreground">
                {dictionary.nav.pricing}
              </a>
            </li>
          </ul>
        </div>

        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            {dictionary.footer.resources}
          </p>
          <ul className="space-y-1 text-sm">
            <li>
              <a
                href={EXTERNAL_LINKS.docs}
                target="_blank"
                rel="noreferrer noopener"
                className="text-muted-foreground hover:text-foreground"
              >
                Kokonut UI docs
              </a>
            </li>
            <li>
              <a
                href={EXTERNAL_LINKS.supabase}
                target="_blank"
                rel="noreferrer noopener"
                className="text-muted-foreground hover:text-foreground"
              >
                Supabase
              </a>
            </li>
          </ul>
        </div>

        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            {dictionary.nav.language}
          </p>
          <ul className="space-y-1 text-sm">
            {SUPPORTED_LOCALES.map((value) => (
              <li key={value}>
                <Link to={publicLocalePath(value)} className="text-muted-foreground hover:text-foreground">
                  {value === "en" ? "English" : "Bahasa Indonesia"}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-border py-4">
        <p className="mx-auto w-full max-w-6xl px-4 text-xs text-muted-foreground">
          © {new Date().getFullYear()} {APP_NAME}. {dictionary.footer.rights}
        </p>
      </div>
    </footer>
  );
};
